export default __webpack_public_path__ + "static/media/form_background.9ae7437d.png";